import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, DollarSign, Ship } from 'lucide-react';
export function RecentShipments() {
  const shipments = [{
    boat: '1996 Sea Ray Sundancer 460',
    route: 'Rochester, NY → Fort Lauderdale, FL',
    price: '$16,495',
    img: 'https://cdn.magicpatterns.com/uploads/xzbsRQVifiT1SmwEB7kTjn/1996_Sea_Ray_Sundancer_460.jpg'
  }, {
    boat: '2024 Maycraft 208',
    route: 'Plymouth, MA → Cos Cob, CT',
    price: '$1,195',
    img: 'https://cdn.magicpatterns.com/uploads/3Vse775U7pdvieboaQCWbL/2024_Maycraft_208.jpg'
  }, {
    boat: "2018 Tahoe 24'",
    route: 'Palm Bay, FL → Kalkaska, MI',
    price: '$3,295',
    img: 'https://cdn.magicpatterns.com/uploads/8sv35UwYTth1NZ2UXUqFuo/2018_Tahoe.jpg'
  }, {
    boat: '2019 Axis A24',
    route: 'Nashville, TN → Scottsdale, AZ',
    price: '$3,595',
    img: 'https://cdn.magicpatterns.com/uploads/77vPLZGwMWNvxvrREoHmam/2019_Axis_A24.jpg'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-270">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-272">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-273">
            Recent Boat Shipments
          </h2>
          <p className="text-lg text-slate-600" data-id="element-274">
            Real examples of our nationwide boat transport services. We provide
            transparent, competitive boat hauling quotes for vessels of all
            sizes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-275">
          {shipments.map((shipment, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="bg-white rounded-xl overflow-hidden shadow-md border border-slate-100 hover:shadow-xl transition-shadow" data-id="element-276">
              <div className="h-40 overflow-hidden" data-id="element-277">
                <img src={shipment.img} alt={`${shipment.boat} transport`} className="w-full h-full object-cover" data-id="element-278" />
              </div>
              <div className="p-5 space-y-3" data-id="element-279">
                <div className="flex items-center gap-2 text-brand-navy font-bold text-lg" data-id="element-280">
                  <Ship className="w-5 h-5 text-brand-red" data-id="element-281" />
                  {shipment.boat}
                </div>
                <div className="flex items-start gap-2 text-sm text-slate-600" data-id="element-282">
                  <MapPin className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" data-id="element-283" />
                  <span data-id="element-284">{shipment.route}</span>
                </div>
                <div className="flex items-center gap-2 text-brand-navy font-black text-xl pt-2 border-t border-slate-100" data-id="element-285">
                  <DollarSign className="w-5 h-5 text-green-600" data-id="element-286" />
                  {shipment.price}
                </div>
              </div>
            </motion.div>)}
        </div>
        <p className="text-xs text-slate-400 text-center mt-8" data-id="element-287">
          * Prices shown are real-world examples. Actual boat shipping costs
          vary based on exact dimensions, route, season, and current fuel
          prices.
        </p>
      </div>
    </section>;
}